'use client';
/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Heading, Show } from '@chakra-ui/react';
import Masonry from 'react-masonry-css';
import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/styles.css';
/* Internal Imports */
// Components
import AdComponent from '@app-ps/Components/Card/AdComponent';
import FilterTag from '@app-ps/Components/Card/FilterTag';
import LandscapeComponent from '@app-ps/Components/Card/LandscapeComponent';
import PortraitComponent from '@app-ps/Components/Card/PortraitComponent';
import YouTubeComponent from '@app-ps/Components/Card/YouTubeComponent';
import config from '@config';

/* Style */

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
export default function Gallery({ sectionContent }) {
  const { galleryItem, listOfActiveFilterTags, title, style, backgroundStyle } =
    sectionContent;
  // console.log(backgroundStyle, 'gallerydata');
  const [selectedTag, setSelectedTag] = useState('All');
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [preload, setPreload] = useState(10);
  // const isLargeScreen = useBreakpointValue({ base: false, lg: true });
  // useEffect(() => {
  //   const imageUrls = galleryItem
  //     ?.filter(item => {
  //       return !!item?.image?.url;
  //     })
  //     .map(img => ({
  //       image: img?.image?.url,
  //       caption: img?.image?.alt,
  //     }));

  //   // .filter(val => {
  //   //   return val.display_status === '1';
  //   // })

  //   setImages(imageUrls);
  //   // console.log('imageUrls', imageUrls, galleryItem);
  // }, [galleryItem]);
  useEffect(() => {
    const imageUrls = galleryItem
      ?.filter(item => !!item?.image?.url) // Safely access image.url
      .map(img => ({
        src: img?.image?.url,
        // caption: img?.image?.alt || '', // Provide a default empty caption if alt is missing
      }));

    setImages(imageUrls);
  }, [galleryItem]);

  const allTagExists = listOfActiveFilterTags?.some(
    tag => tag.tagName === 'All'
  );

  const filterTags = allTagExists
    ? listOfActiveFilterTags?.filter(
        item => item._modelApiKey === 'project_samskriti_gallery_tag'
      )
    : [
        { id: 'All', tagName: 'All' },
        ...listOfActiveFilterTags?.filter(
          item => item._modelApiKey === 'project_samskriti_gallery_tag'
        ),
      ];

  const renderGalleryItem = (item, index) => {
    if (item.videoUrl) {
      const thumbnailUrl = item.thumbnailImage?.url;
      return (
        <YouTubeComponent
          key={index}
          item={item}
          thumbnailUrl={thumbnailUrl}
          backgroundStyle={sectionContent.backgroundStyle}
        />
      );
    } else if (item.image) {
      if (item.imageType === 'portrait') {
        return (
          <PortraitComponent
            key={index}
            item={item}
            backgroundStyle={sectionContent.backgroundStyle}
          />
        );
      } else if (item.imageType === 'landscape') {
        return (
          <LandscapeComponent
            key={index}
            item={item}
            backgroundStyle={sectionContent.backgroundStyle}
          />
        );
      }
    } else if (item._modelApiKey === 'project_samskriti_gallery_ad') {
      return <AdComponent key={index} item={item} />;
    }
    return null;
  };

  const filteredGalleryItems =
    selectedTag === 'All'
      ? galleryItem
      : galleryItem.filter(item =>
          item.galleryFilterTag.some(tag => tag.tagName === selectedTag)
        );

  // const handleOpenLightbox = index => {
  //   setPhotoIndex(index);
  //   setIsOpen(true);
  // };

  const handleOpenLightbox = filteredIndex => {
    // Find the index in the full images array that matches the clicked image
    const actualIndex = images.findIndex(
      img => img.src === filteredGalleryItems[filteredIndex]?.image?.url
    );

    if (actualIndex !== -1) {
      setPhotoIndex(actualIndex); // Set the correct index for LightBox
      setIsOpen(true);
    }
  };

  // const lightBoxHandler = (state, index) => {
  //   setIsOpen(state);
  //   setPhotoIndex(index);
  // };

  const isWithFilter = style === 'with-filter';

  const bgColors = {
    amber: '',
    brown: '#010509',
    default: isWithFilter ? 'black' : 'white',
  };

  const bgImages = {
    amber: `${config.imgPath}/d/46272/1722881976-group-1171277627.png`, // Amber background
    brown: `${config.imgPath}/d/46272/1724182855-group-1171277937.jpg`, // Brown background
    default: isWithFilter
      ? ''
      : `${config.imgPath}/d/46272/1721276258-group-1171277627.jpg`, // Default background
  };

  const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    800: 2,
    600: 1,
  };
  // console.log(images);
  return (
    <Box
      // pt={{ base: '6rem', md: '6rem' }}
      mt={{
        base: sectionContent?.backgroundStyle === 'amber' ? '-4rem' : '0', // Adjust '4rem' or any value you want for non-default
        md: '0',
      }}
      pt={{
        base: sectionContent?.backgroundStyle === 'default' ? '3rem' : '6rem', // Adjust '4rem' or any value you want for non-default
        md: '6rem',
        xl: sectionContent?.backgroundStyle === 'amber' ? '12rem' : '6rem', // Adjust '4rem' or any value you want for non-default

        '2xl': sectionContent?.backgroundStyle === 'amber' ? '15rem' : '6rem', // Adjust '4rem' or any value you want for non-default
      }}
      pb={{
        base: sectionContent?.backgroundStyle === 'brown' ? '12rem' : '4rem',
        md: '12rem',
      }}
      position={'relative'}
      width="100%"
      background={`url('${
        bgImages[sectionContent?.backgroundStyle]
      }') no-repeat`}
      bgColor={bgColors[sectionContent?.backgroundStyle]}
    >
      {title && (
        <Heading
          as="h2"
          size="lg"
          fontFamily={'var(--FedraSerifDisplay-light)'}
          fontWeight={700}
          fontSize={{ base: '1.5rem', md: '2.625rem', '2xl': '52px' }}
          lineHeight={{ base: '3.15rem' }}
          letterSpacing={'0.16px'}
          textAlign="center"
          color={
            isWithFilter || sectionContent?.backgroundStyle === 'brown'
              ? 'white'
              : 'black'
          }
          mb={{ base: '4', md: '3rem' }}
          mt="7rem"
        >
          {title}
        </Heading>
      )}

      {isWithFilter && filterTags?.length > 0 && (
        <Box
          display="flex"
          justifyContent={{ base: 'flex-start', md: 'center' }}
          bg="black"
          // justifyContent="center"
          // mx={{ base: '13rem' }}
          mb={{ base: '30px', md: '50px' }}
          sx={{
            '::-webkit-scrollbar': {
              height: '8px', // Adjust scrollbar height if needed
              backgroundColor: 'black', // Set scrollbar background color to black
            },
            '::-webkit-scrollbar-thumb': {
              backgroundColor: 'black', // Make scrollbar thumb blend with the background
            },
            '::-webkit-scrollbar-track': {
              backgroundColor: 'black', // Set the track to black
            },
          }}
          overflow="auto"
          whiteSpace="nowrap"
        >
          {filterTags?.map(tag => (
            <FilterTag
              key={tag.id}
              tag={tag}
              onClick={() => setSelectedTag(tag.tagName)}
              selected={selectedTag === tag.tagName}
            />
          ))}
        </Box>
      )}

      <Box
        // mx={{ lg: '5rem', xl: '8rem', '2xl': '13rem', '3xl': 'auto' }}
        mx={{ lg: '5rem', xl: '8rem', '2xl': 'auto', '3xl': 'auto' }}
        boxSizing="border-box"
        maxWidth={{ '2xl': '1500px' }}
      >
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
          gutter={{ base: '1rem', '2xl': '1rem' }}
        >
          {filteredGalleryItems.map((item, index) => (
            <Box
              key={index}
              height={item.height || 'auto'}
              width="100%"
              onClick={
                () =>
                  item._modelApiKey !== 'project_samskriti_gallery_ad' &&
                  !item.videoUrl &&
                  handleOpenLightbox(index) // Pass the filtered gallery's index
              }
              cursor="pointer"
            >
              {renderGalleryItem(item, index)}
            </Box>
          ))}
        </Masonry>
      </Box>
      <Show above="md">
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          carousel={{ preload }}
          index={photoIndex}
          slides={images}
          plugins={[Thumbnails]}
          animation={{ fade: 0 }}
          controller={{ closeOnPullDown: true, closeOnBackdropClick: true }}
          thumbnails={{
            preload: 10,
          }}
        />
      </Show>
      <style jsx global>
        {`
      .my-masonry-grid {
    display: flex;
    margin-left: -1rem;
    width: auto;
  }

  @media (min-width: 1536px) {
    .my-masonry-grid {
      margin-left: 0;
    }
  }
          }
          .yarl__thumbnails_thumbnail.yarl__thumbnails_thumbnail_active {
            border-width: 2.5px;
          }

          .yarl__thumbnails_thumbnail {
            border-width: 0.1px;
            border: none;
          }
          .my-masonry-grid_column {
            padding-left: 1rem; /* gutter size */
            background-clip: padding-box;
          }
          .my-masonry-grid_column > div {
            margin-bottom: 1.5rem;
          }
          .yarl__thumbnails_track {
            gap: 3px;
          }
        `}
      </style>
    </Box>
  );
}
